var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaturity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4121 9.72941C40.4121 7.52282 38.6281 5.73877 36.4215 5.73877L6.98463 5.73877C4.77804 5.73877 2.99399 7.52282 2.99399 9.72941L2.99399 15.1285L40.4121 15.1285V9.72941Z",
    fill: "#D5DFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94699 15.1284L2.94699 37.9924C2.94699 40.199 4.73104 41.9831 6.93763 41.9831H36.3745C38.5811 41.9831 40.3651 40.199 40.3651 37.9924V15.1284L2.94699 15.1284Z",
    fill: "#D5DFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4651 6.78263C37.4651 4.57604 35.6811 2.79199 33.4745 2.79199H4.03764C1.83105 2.79199 0.0469971 4.57604 0.0469971 6.78263V12.1817H37.4651V6.78263Z",
    fill: "#8BADF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.1816V35.0457C0 37.2523 1.78405 39.0363 3.99064 39.0363H33.4275C35.6341 39.0363 37.4181 37.2523 37.4181 35.0457V12.1816H0Z",
    fill: "url(#paint0_linear_3706_9487)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2208 7.11128C11.2208 7.58076 10.7044 8.0033 10.0471 8.0033C9.38979 8.0033 8.87335 7.62771 8.87335 7.11128V1.87542C8.87335 1.40594 9.38979 0.983398 10.0471 0.983398C10.7044 0.983398 11.2208 1.35899 11.2208 1.87542V7.11128Z",
    fill: "#6170B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5449 7.11128C28.5449 7.58076 28.0284 8.0033 27.3712 8.0033C26.7139 8.0033 26.1974 7.62771 26.1974 7.11128V1.87542C26.1974 1.40594 26.7139 0.983398 27.3712 0.983398C28.0284 0.983398 28.5449 1.35899 28.5449 1.87542V7.11128Z",
    fill: "#6170B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.54477,
    y: 14.9448,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54477,
    y: 22.3125,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54477,
    y: 29.6797,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9123,
    y: 14.9448,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9123,
    y: 22.3125,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9123,
    y: 29.6797,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2797,
    y: 14.9448,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2797,
    y: 22.3125,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2797,
    y: 29.6797,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6472,
    y: 14.9448,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6472,
    y: 22.3125,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6472,
    y: 29.6797,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#7C97E8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9758,
    y: 28.0083,
    width: 7.76318,
    height: 7.76318,
    rx: 3.88159,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6472,
    y: 29.6797,
    width: 4.42049,
    height: 4.42049,
    rx: 0.736748,
    fill: "#FEB754"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3706_9487",
    x1: 1.49265,
    y1: 13.1028,
    x2: 35.0147,
    y2: 60.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7BFFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaturity);
export default __webpack_public_path__ + "static/media/maturity.662220d64ef2167d299cccbb231fff24.svg";
export { ForwardRef as ReactComponent };